export type Bono = {
  number: string
  title: string
  price: string
  body: string
  kicker: string
  image: string
  alt: string
}

export const bonos: Bono[] = [
  {
    number: 'Bono 01',
    title: 'Brief Premium 15',
    price: '17 USD',
    body: 'El formulario de diagnóstico para descubrir la fiesta ideal antes de proponer nada. Preguntas estratégicas para la quinceañera y para los papás: gustos, prioridades, presupuesto, miedos y nivel de producción esperado, más la estructura para interpretar las respuestas.',
    kicker:
      'Llegas a la primera reunión con una herramienta profesional en la mano.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bbb79366-730c-4c58-9005-957e3fff63cd.jpg',
    alt: 'Formulario de diagnóstico impreso sobre mantel de lino marfil, junto a una lapicera dorada.',
  },
  {
    number: 'Bono 02',
    title: 'Mapa Visual de Concepto',
    price: '15 USD',
    body: 'La guía para convertir ideas sueltas en un concepto claro y vendible: nombre del concepto, emoción principal, paleta, texturas, elementos protagonistas y qué evitar. Incluye cinco estilos desarrollados (elegante clásico, glam moderno, romántico editorial, luxury minimal y fantasy night).',
    kicker: 'Se acabó el "quiero algo lindo".',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d80d93b1-8316-4f73-ad04-3ce9bf53df83.jpg',
    alt: 'Moodboard de concepto con paleta de colores champagne, telas y flores secas sobre cartulina marfil.',
  },
  {
    number: 'Bono 03',
    title: 'Checklist Salón Perfecto',
    price: '21 USD',
    body: '75 puntos para evaluar una locación antes de dar el anticipo: accesos, capacidad, baños, cocina, potencia eléctrica, climatización, tiempos de montaje, sonido, restricciones, proveedores externos y costos ocultos.',
    kicker: 'Un solo punto de esta lista vale más que todo el sistema.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/06890fce-411f-4b33-8207-8b27c16dfd57.jpg',
    alt: 'Checklist de inspección de salón impresa en un portapapeles dorado, con el salón desenfocado detrás.',
  },
  {
    number: 'Bono 04',
    title: 'Kit de Mensajes VIP',
    price: '15 USD',
    body: 'WhatsApps y emails listos para copiar y adaptar: confirmar reuniones, pedir presupuestos, hacer seguimiento de una propuesta, confirmar servicios, recordar detalles la semana previa y poner límites con elegancia.',
    kicker: 'Nunca más quedarte mirando el cursor sin saber cómo contestar.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/332a6c9d-58cc-4055-a54b-40a1322daac6.jpg',
    alt: 'Teléfono sobre mantel de lino mostrando una conversación de WhatsApp con un proveedor, junto a una libreta dorada.',
  },
  {
    number: 'Bono 05',
    title: 'Guía Express de Mesas e Invitados',
    price: '12 USD',
    body: 'El tema más caótico de cualquier fiesta de 15, ordenado: clasificación por grupos, RSVP, acompañantes, restricciones alimentarias y ubicación de mesas evitando conflictos familiares.',
    kicker:
      'Entregas al salón y al catering una lista clara, no capturas de WhatsApp.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/937a42b1-6799-48e3-9650-53a94d437386.jpg',
    alt: 'Plano de mesas impreso con diagramas de mesas redondas sobre una superficie de lino marfil.',
  },
]
